var map = {
	"./burger.svg": "d650",
	"./clock.svg": "53db",
	"./close.svg": "ab53",
	"./location.svg": "9dd0",
	"./next.svg": "e035",
	"./prev.svg": "6f4d",
	"./profile.svg": "ad23",
	"./program/ai.svg": "3413",
	"./program/climat.svg": "ee91",
	"./program/compas.svg": "2c63",
	"./program/dna.svg": "67ba",
	"./program/energy.svg": "51a1",
	"./program/medicina.svg": "0f56",
	"./program/security.svg": "1d6f",
	"./program/society.svg": "441a",
	"./program/space.svg": "f533",
	"./program/technology.svg": "41da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc98";